import React from 'react';

import Head from 'next/head';

import AboutUs from '@/components/AboutUs';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import PopularCategoriesStatic from '@/components/PopularCategoriesStatic';

const Home = () => {
  return (
    <div className="page-wrapper">
      <Head>
        <meta name="description" content="CallAPro - Find a Home Service Professional Near You" />
        <title>Find Home Service Pros Near You</title>
      </Head>
      <Header />
      <AboutUs />
      <PopularCategoriesStatic />
      <Footer />
    </div>
  );
};

export default Home;
